"use client";

import React, { useState } from "react";
import { motion } from "framer-motion";
import Image from "next/image";
import SectionHeading from "./SectionHeading";
import { aiIcons, devopsIcons, fullstackIcons } from "@/lib/iconSets";

const TechStack = () => {
  const categories = ["AI Technologies", "DevOps & MLOps", "Fullstack Development"];
  const [activeCategory, setActiveCategory] = useState(categories[0]);

  const getTechnologies = (category: string) => {
    switch (category) {
      case "AI Technologies":
        return aiIcons;
      case "DevOps & MLOps":
        return devopsIcons;
      case "Fullstack Development":
        return fullstackIcons;
      default:
        return [];
    }
  };

  return (
    <section id="techstack" className="py-20 px-6 bg-secondary/30">
      <div className="container max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-10">
          <SectionHeading title="Tech Stack" />
          
          {/* Tabs */}
          <div className="flex flex-wrap gap-4 mt-4 md:mt-0">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`text-sm transition-all duration-300 hover:text-primary relative
                  after:absolute after:h-[2px] after:bg-primary after:bottom-[-4px] after:left-0 
                  after:transition-all after:duration-300 after:ease-in-out
                  ${activeCategory === category 
                    ? "font-bold text-primary after:w-full" 
                    : "text-secondary-foreground after:w-0"
                  }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
        
        {/* Technologies for the active tab */}
        <motion.div
          key={activeCategory}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className="flex flex-wrap justify-center gap-4"
        >
          {getTechnologies(activeCategory).map((tech, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: index * 0.05 }}
              className="group"
            >
              <div className="px-4 py-3 bg-card border border-border rounded-lg shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1 flex flex-row items-center gap-3">
                <Image 
                  src={tech.icon} 
                  alt={tech.name} 
                  width={24}
                  height={24}
                  className="object-contain" 
                />
                <span className="text-sm font-medium">{tech.name}</span>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TechStack;
